/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNftRewardPrizeBody
 */
export interface UpdateNftRewardPrizeBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNftRewardPrizeBody
     */
    prizeRevealName: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftRewardPrizeBody
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftRewardPrizeBody
     */
    sortOrder: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftRewardPrizeBody
     */
    onlyAvailableAfterWins?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftRewardPrizeBody
     */
    rewardConfigId?: string;
}

/**
 * Check if a given object implements the UpdateNftRewardPrizeBody interface.
 */
export function instanceOfUpdateNftRewardPrizeBody(value: object): value is UpdateNftRewardPrizeBody {
    if (!('prizeRevealName' in value) || value['prizeRevealName'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function UpdateNftRewardPrizeBodyFromJSON(json: any): UpdateNftRewardPrizeBody {
    return UpdateNftRewardPrizeBodyFromJSONTyped(json, false);
}

export function UpdateNftRewardPrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNftRewardPrizeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'prizeRevealName': json['prizeRevealName'],
        'quantity': json['quantity'],
        'sortOrder': json['sortOrder'],
        'onlyAvailableAfterWins': json['onlyAvailableAfterWins'] == null ? undefined : json['onlyAvailableAfterWins'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
    };
}

export function UpdateNftRewardPrizeBodyToJSON(json: any): UpdateNftRewardPrizeBody {
    return UpdateNftRewardPrizeBodyToJSONTyped(json, false);
}

export function UpdateNftRewardPrizeBodyToJSONTyped(value?: UpdateNftRewardPrizeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prizeRevealName': value['prizeRevealName'],
        'quantity': value['quantity'],
        'sortOrder': value['sortOrder'],
        'onlyAvailableAfterWins': value['onlyAvailableAfterWins'],
        'rewardConfigId': value['rewardConfigId'],
    };
}

